import { CookieContext } from './index'
import Cookie from 'cookie'
import { Request, Response } from 'express'
import addDays from 'date-fns/addDays'

export default function({ req, res }: { req: Request; res: Response }): CookieContext {
  const header = req.header('Cookie')
  const cookies = header && Cookie.parse(header)

  return {
    get: (cookieName: string) => {
      return cookies && cookies[cookieName.toLowerCase()]
    },

    /**
     * Note: This will generally not work as expected with HTTP response streaming.
     *
     * The return value (a boolean) indicates whether the Set-Cookie was successfully set.
     */
    set: (cookieName, cookieValue, cookieOptions) => {
      // If a number is passed for the "expires" option, it is interpreted as "X days from now"
      let expiresAt = cookieOptions && cookieOptions.expires
      if (typeof expiresAt === 'number') {
        expiresAt = addDays(new Date(), expiresAt)
      }

      if (!res.headersSent) {
        res.cookie(cookieName, cookieValue, {
          expires: expiresAt,
          domain: cookieOptions && cookieOptions.domain,
          path: cookieOptions && cookieOptions.path,
          httpOnly: cookieOptions && cookieOptions.httpOnly,
          secure: cookieOptions && cookieOptions.secure
        })

        return true
      } else {
        return false
      }
    }
  }
}
